import React from "react";
import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import BuyerContracts from "../@Components/Products/BuyerContracts";

const BuyerContractsPage: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <BuyerContracts />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default BuyerContractsPage;
